import { Row, Col, Select, Input, Spin, Form, Typography } from "antd";
import { filterOption } from "Pages/PlannerView/PlannerFilterFormFieldComp";
import { LOD1, QuestionType } from "utilFunctions/Constants/Constants";
import { StyledFormItem } from "Pages/DRS/DRSFooterFilter";
import { IUserInfo } from "utilFunctions/CommonInterfaces/userInterface";
import { useContext, useEffect, useMemo } from "react";
import { UserInfoContext } from "Context/CommonContext";
import useQuizDrawer from "Pages/MySchedule/MyScheduledBeta/quiz/hooks/useQuizDrawer";
import { BASE_URL } from "utilFunctions/Constants/urlConstants";
import { useQuizContext } from "Pages/MySchedule/MyScheduledBeta/quiz/context/QuizContext";

const QuizDetailsForm = ({ form }: any) => {
  const { fetchCourseData, isLoading, courseData } = useQuizDrawer();
  const userInfo = useContext<IUserInfo>(UserInfoContext);
  const { userStreams, subjectsListing } = userInfo || {};
  const { editableQuiz } = useQuizContext();
  const fkStream = Form.useWatch("streamId", form);
  const fkSubject = Form.useWatch("subjectId", form);
  useEffect(() => {
    if (fkStream && fkSubject) {
      console.log("Its working---", fkStream, fkSubject);
      const streamId = typeof fkStream == "object" ? fkStream.value : fkStream;
      const subjectId =
        typeof fkSubject == "object" ? fkSubject.value : fkSubject;
      fetchCourseData(
        BASE_URL +
          `courses?limit=500&active=1&fkStream=${streamId}&&fkSubject=${subjectId}&isMainSyllabus=true&status=Published&fex=true`
      );
    }
  }, [fkStream, fkSubject]);
  const CoursesList =
    useMemo(() => {
      return courseData?.map((course: any) => ({
        label: course.courseName,
        value: course.id,
        key: course.id,
      }));
    }, [courseData]) || [];
  useEffect(() => {
    if (!CoursesList.length && !editableQuiz.id) return;
    const course = CoursesList.find(
      (ele: any) => ele.value === editableQuiz.courseId
    );
    form.setFieldValue("courseId", course?.value);
  }, [CoursesList, editableQuiz]);
  const colProps = {
    xs: 24,
    sm: 24,
    md: 12,
    lg: 8,
    xl: 8,
    xxl: 8,
  };

  return (
    <Row gutter={[24, 24]}>
      {isLoading && <Spin />}

      <Col {...colProps}>
        <StyledFormItem
          label="Quiz Title"
          name="quizTitle"
          rules={[{ required: true, message: "required" }]}
        >
          <Input placeholder="title" maxLength={100} />
        </StyledFormItem>
      </Col>
      <Col {...colProps}>
        <StyledFormItem
          label={<Typography.Text>Question Type</Typography.Text>}
          name="questionType"
          rules={[{ required: true, message: "required" }]}
        >
          <Select
            showSearch
            options={QuestionType}
            placeholder="select"
            filterOption={filterOption}
            disabled={false}
          />
        </StyledFormItem>
      </Col>

      <Col {...colProps}>
        <StyledFormItem
          label={<Typography.Text>LOD1</Typography.Text>}
          name="lod1"
          rules={[{ required: true, message: "required" }]}
        >
          <Select
            showSearch
            options={LOD1}
            placeholder="select"
            filterOption={filterOption}
            disabled={false}
          />
        </StyledFormItem>
      </Col>
      <Col {...colProps}>
        <StyledFormItem
          label="Stream"
          name="streamId"
          rules={[{ required: true, message: "required" }]}
        >
          <Select
            showSearch
            placeholder="select"
            options={userStreams}
            filterOption={filterOption}
          />
        </StyledFormItem>
      </Col>

      <Col {...colProps}>
        <StyledFormItem
          label="Subject"
          name="subjectId"
          rules={[{ required: true, message: "required" }]}
        >
          <Select
            showSearch
            options={subjectsListing}
            placeholder="select"
            filterOption={filterOption}
          />
        </StyledFormItem>
      </Col>

      <Col {...colProps}>
        <StyledFormItem
          label="Syllabus Master"
          name="courseId"
          rules={[{ required: true, message: "required" }]}
        >
          <Select
            showSearch
            options={CoursesList}
            placeholder="select"
            filterOption={filterOption}
          />
        </StyledFormItem>
      </Col>
    </Row>
  );
};

export default QuizDetailsForm;
